import React, { useState } from 'react';
import { IoCreateOutline } from 'react-icons/io5';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useChatHistory } from '@Context/ChatHistoryContext';

import GPT from '../components/gpt/views/chat/index';
import DeleteChatModal from '../components/gpt/views/modals/DeleteChatModal';
import ConversationHistory from '../components/gpt/side/ConversationHistory';

const GPTPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [search, setSearch] = useState('');
  const [showDelete, setShowDelete] = useState(false);

  const { dispatch } = useChatHistory();

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <div className="flex h-[94vh] flex-col bg-[#fbfcff] md:h-[100vh]">
        <DeleteChatModal
          message={newTitle}
          isOpen={showDelete}
          onCancel={() => setShowDelete(false)}
        />
        <div className="flex h-full flex-col justify-start">
          <div className="relative flex h-full flex-row items-start gap-4 border-gray-400 bg-primary-50 md:mx-2 md:my-2 md:rounded-xl md:border">
            <GiHamburgerMenu
              className={`absolute z-50 ms-3 mt-6 cursor-pointer text-2xl text-blue-900`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            />

            <div
              className={`${isMenuOpen ? 'flex flex-col' : 'hidden'} absolute z-40 h-full rounded-br-lg rounded-tr-lg bg-white p-4 md:relative md:z-0 md:w-1/3 md:rounded-xl`}
            >
              <div className="flex items-center justify-between gap-5 text-blue-900">
                <input
                  placeholder="Search Chats"
                  maxLength={200}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="ms-8 flex w-full rounded-lg border border-gray-500 p-2 text-sm focus:outline-blue-800"
                />

                <span className="cursor-pointer text-gray-500 hover:text-blue-900">
                  <IoCreateOutline
                    size={25}
                    onClick={() =>
                      dispatch({
                        type: 'SET_CURRENT_CHAT',
                        payload: { id: null },
                      })
                    }
                  />
                </span>
              </div>

              <label className="mb-3 mt-5 flex text-xs font-semibold text-gray-500">
                Chat History
              </label>
              <div className="custom-scroll flex h-0 flex-grow flex-col gap-y-1 overflow-y-auto pr-3">
                <ConversationHistory
                  search={search}
                  newTitle={newTitle}
                  setNewTitle={setNewTitle}
                  setShowDelete={setShowDelete}
                />
              </div>
            </div>
            {/* Overlay on tab */}
            <div
              className={`${isMenuOpen ? 'flex md:hidden' : 'hidden'} pointer-events-none absolute z-20 h-full w-full bg-black opacity-50`}
            />
            <GPT />
          </div>
        </div>
      </div>
    </React.Suspense>
  );
};

export default GPTPage;
